<template>
  <div class="appraisal-cont">
    <navBar :title="'职业兴趣探索测评'" @onClickLeft="handleBack"/>
    <div class="appraisal-top-bg1"></div>
    <div class="appraisal-top-bg2">
      <div class="appraisal-btn2" v-if="submitted" @click="viewAppraisal">查看报告</div>
      <div class="appraisal-btn1" v-else @click="goAppraisal">去测评</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import navBar from '../components/navBar.vue';
export default {
  name: "appraisal",
  components: {
    navBar
  },
  data() {
    return {
      submitted: false, // 是否进行过测评
      pdf_link: "",
      url: "",
      userInfo: {},
    };
  },
  destroyed(){
    window.removeEventListener("popstate", this.back, false); //false阻止默认事件
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("WDuserInfo") || {});
    this.getStatus();
  },
  mounted() {
    // if (window.history && window.history.pushState) {
    //   // 往历史记录里面添加一条新的当前页面的url
    //   history.pushState(null, null, document.URL);
    //   // 给 popstate 绑定一个方法 监听页面刷新
    //   window.addEventListener("popstate", this.back, false); //false阻止默认事件
    // }
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    getStatus() {
      const userUcode = this.userInfo.userUcode;
      axios
        .get(
          // `https://open.xjy.cn/dev/ceping_wdeduc/get_report?ucode=${userUcode}`
          `https://open.xjy.cn/api/ceping_wdeduc/get_report?ucode=${userUcode}`
        )
        .then((response) => {
          if (response.data.success) {
            this.submitted = response.data.data.submitted;
            if (response.data.data.submitted) {
              this.pdf_link = response.data.data.pdf_link;
              this.url = response.data.data.url;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goAppraisal() {
      const userUcode = this.userInfo.userUcode;
      // window.location.href = `https://open.xjy.cn/test/wdeduc/auth-router?ucode=${userUcode}`;
      window.location.href = `https://open.xjy.cn/main/wdeduc/auth-router?ucode=${userUcode}`;
    },
    viewAppraisal() {
      window.location.href = this.url;
    },
  },
};
</script>

<style lang="less" scoped>
.appraisal-cont {
  width: 100%;
  height: 100%;
  font-size: 0;
  .appraisal-top-bg1 {
    width: 100%;
    height: 1384px;
    background: url("https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/appraisal_page1.png") no-repeat;
    background-size: cover;
    position: relative;
  }
  .appraisal-top-bg2 {
    width: 100%;
    height: 1490px;
    background: url("https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/appraisal_page2.png") no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .appraisal-btn1 {
    width: 578px;
    height: 100px;
    position: absolute;
    background: url("https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/go_appraisal.png") no-repeat;
    background-size: cover;
    bottom: 80px;
  }
  .appraisal-btn2 {
    width: 578px;
    height: 100px;
    position: absolute;
    background: url("https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/view_appraisal.png") no-repeat;
    background-size: cover;
    bottom: 80px;
  }
}
</style>
